// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2gLQG","option":"styles_option__1B2_6","active":"styles_active__3LyaS"};